// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const FulfillmentType = {
  InStore: {
    Name: 'In Store',
    Value: 'in-store',
    Icon: 'Store',
    Variant: 'default',
  },
  Pickup: {
    Name: 'Pickup',
    Value: 'pickup',
    Icon: 'ShoppingBasket',
    Variant: 'secondary',
  },
  Delivery: {
    Name: 'Delivery',
    Value: 'delivery',
    Icon: 'Truck',
    Variant: 'brand',
  },
  Shipping: {
    Name: 'Shipping',
    Value: 'shipping',
    Icon: 'Package',
    Variant: 'info',
  },
} as const

export type FulfillmentTypeValue = (typeof FulfillmentType)[keyof typeof FulfillmentType]['Value']
